export default {
	search(params, cb) {
		this.http
			.get('/punch/search', {
				params
			})
			.then((response) => cb && cb(response))
	},
	update(form, cb, ecb) {
		this.http
			.post('/punch/update', form)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	searchPunchUser(params, cb) {
		this.http
			.get('/punch/searchPunchUser/full', {
				params
			})
			.then((response) => cb && cb(response))
	},
	statusPunchUser(id, to, cb, ecb) {
		this.http
			.get(`/punch/statusPunchUser/${id}/${to}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	getPunchUserById(puid, cb, ecb) {
		this.http
			.get(`/punch/getPunchUserById/${puid}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	getPunchCards(params, cb, ecb) {
		this.http
			.get(
				`/punch/getPunchUsers/${params.status}/${params.pageno}/${params.pagesize}`,
				{}
			)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	getById(id, cb, prof = '') {
		this.http
			.get(`/punch/getById/${id}/${prof}`, {})
			.then((response) => cb && cb(response))
	},
	getByIds(ids, cb, ecb, config) {
		this.http
			.get(`/punch/getByIds/${ids}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	apply(id, cb, config = {}, ecb = null) {
		this.http
			.get(`/punch/apply/${id}`, config)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	send(pid, uids, qty, cb, config = {}, ecb = null) {
		this.http
			.get(`/punch/send/${pid}/${uids}/${qty}`, config)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	status(pid, tostatus, cb, config = {}, ecb = null) {
		this.http
			.get(`/punch/status/${pid}/${tostatus}`, config)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	remove(puid, cb, config = {}, ecb = null) {
		this.http
			.get(`/punch/removePunchUser/${puid}`, config)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	activate(puid, cb, config = {}, ecb = null) {
		this.http
			.get(`/punch/activate/${puid}`, config)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	deactivate(puid, cb, config = {}, ecb = null) {
		this.http
			.get(`/punch/deactivate/${puid}`, config)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	complete(puid, cb, ecb) {
		this.http
			.get(`/punch/complete/${id}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	buy(pid, cb, config = {}, ecb = null) {
		this.http
			.post(`/punch/buy/${pid}`, config)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	getLog(puid, params, cb) {
		this.http
			.get(`/punch/getLog/${puid}`, params)
			.then((response) => cb && cb(response))
	},
	searchOrder(params, cb) {
		this.http
			.get('/punch/searchOrder', {
				params
			})
			.then((response) => cb && cb(response))
	},
	resend(poid, cb) {
		this.http
			.get(`/punch/resend/${poid}`)
			.then((response) => cb && cb(response))
	}
}
